import { 
	SIGNOUT_SUCCESS, 
	SIGNUP_SUCCESS, 
	SET_IS_VERIFIED,
	SET_IS_APPROVED,
	SET_USER_DEVICE_ID
} from '../types';

import FingerprintJS from '@fingerprintjs/fingerprintjs';

import { showAlert, hideAlert } from './uiActions';
import { checkEmailVerifiedAndApproved } from '../../api';

export const signIn = (credentials) => {
	return (dispatch, getState, {getFirestore,getFirebase}) => {
		const firebase = getFirebase();
		const fireStore = getFirestore();

		firebase.auth().signInWithEmailAndPassword(
			credentials.email,
			credentials.password
		)
		.then( async (resp) => {
			localStorage.setItem('unity_access', resp.user._lat);

			let role = await fireStore.collection('users').doc(resp.user.uid).get()
			.then(res => res.data() ? res.data().role : null )
			.catch(error => {
				dispatch(showAlert({type:'success', message: error.message}));
				return false;
			});

			if(role === "hc-provider") {
				dispatch(checkedVerified(resp.user.uid));
			};

		}).catch((error) => {
			dispatch(showAlert({type:'error', message: error.message}));
		});
	};
};

export const signUp = (newUser) => {
	return (dispatch, getState, {getFirebase,getFirestore}) => {
		const firebase = getFirebase();
		const fireStore = getFirestore();

		firebase.auth().createUserWithEmailAndPassword(
			newUser.email,
			newUser.password
		)
		.then(async (resp) => {
			fireStore.collection('users').doc(resp.user.uid).set({
				firstName: newUser.firstName,
				lastName: newUser.lastName,
				email: newUser.email,
				userId: resp.user.uid, 
				avatar: null,
				role: "hc-provider",
				position: newUser.position,
				businessName: newUser.businessName,
				facilityAddress: newUser.facilityAddress,
				isVerifield: false,
				approved: false
			});

			await firebase.auth().currentUser.getIdTokenResult(true);

			return resp;
		}).then( async (resp) => {
			const body = {
				email: newUser.email,
				userId: resp.user.uid
			};

			checkEmailVerifiedAndApproved(body);
			dispatch(signUpSuccess(true));
			dispatch(showAlert({type:'emailVerify', message: `Verify your email first. Didn't get the email?`}));
			localStorage.setItem('unity_access', resp.user._lat);
			setTimeout(()=>{
				dispatch(signUpSuccess(false));
			},1000);
		}).catch((error) => {
			dispatch(showAlert({type:'error', message: error.message}))
		});
	};
};

export const signOut = () => {
	return (dispatch, getState, {getFirebase}) => {
		const firebase = getFirebase();

		firebase.auth().signOut().then(() => {
			dispatch({type: SIGNOUT_SUCCESS});
		})
	};
};

export const resetPassword = (email) => {
	return (dispatch, getState, {getFirebase}) => {
		const firebase = getFirebase();

		firebase.auth().sendPasswordResetEmail(email)
		.then((resp) => {
			dispatch(showAlert({type:'success', message: 'Go to mail'}))
		}).catch((error) => {
			dispatch(showAlert({type:'error', message: error.message}))
		});
	};
};

export const resetEmail = (state) => {
	return (dispatch, getState, {getFirebase}) => {
		const firebase = getFirebase();

		firebase.auth().currentUser.updateEmail(state.email)
		.then((resp) => {
			firebase.auth().currentUser.sendEmailVerification();
			dispatch(signOut());
			dispatch(showAlert({type:'emailVerify', message: `Verify your email first. Didn't get the email?`}))
		}).catch((error) => {
			dispatch(showAlert({type:'error', message: error.message}))
		});
	};
};

export const changeAccountInformation = (newData) => {
	return async (dispatch, getState, {getFirestore,getFirebase}) => {
		const state = getState();
		const fireStore = getFirestore();
		const userId =  state.firebase.profile.userId;
	
		fireStore.collection('users').doc(userId).set(newData,{merge: true})
		.then((res) => (
			dispatch(showAlert({type:'success', message: 'Change account information success'}))
		))
		.catch((error) => ( 
			dispatch(showAlert({type:'error', message: error.message}))
		));
	};
};

export const checkedApproved = (uid) => {
	return async (dispatch, getState, {getFirebase,getFirestore}) => {
		const fireStore = getFirestore();

		fireStore.collection('users').doc(uid).get()
		.then(res => {
			if(res.data().approved) {
				dispatch(setApproved(res.data().approved))
			} else {
				dispatch(showAlert({type:'approve', message: 'Your account needs to be approved.'}));
			}
		})
		.catch(error => {
			dispatch(showAlert({type:'error', message: error.message}));
		});
	};
};

export const checkedVerified = (uid) => {
	return async (dispatch, getState, {getFirebase}) => {
		const firebase = getFirebase();

		if(firebase.auth().currentUser) {
			const verifiedUser = await firebase.auth().currentUser.emailVerified;

			if(verifiedUser) {
				dispatch(setVerified(verifiedUser));
				dispatch(hideAlert());
				dispatch(checkedApproved(uid));
				
			} else {
				dispatch(showAlert({type:'emailVerify', message: `Verify your email first. Didn't get the email?`}));
			}
		} else {
			dispatch(setVerified(false));
		};
	};
};

export const sendEmailVerification = (email) => {
	return async (dispatch, getState, {getFirebase}) => {
		const firebase = getFirebase();

		firebase.auth().currentUser.sendEmailVerification();
	};
};

export const setVerified = (result) => {
	return {
		type: SET_IS_VERIFIED,
		payload: result
	};
};

export const setApproved = (result) => {
	return {
		type: SET_IS_APPROVED,
		payload: result
	};
};

export const signUpSuccess = (success) => {
	return {
		type: SIGNUP_SUCCESS,
		payload: success
	};
};

export const createUserDeviceId = (hcProviderId) => {
	return async (dispatch, getState, {getFirestore}) => {
		const firestore = getFirestore();
		const fp = await FingerprintJS.load(); // We recommend to call `load` at application startup.
		const result = await fp.get(); // The FingerprintJS agent is ready.	// Get a visitor identifier when you'd like to.
		const visitorId = result.visitorId; // This is the visitor identifier:
		const timestamp = firestore.FieldValue.serverTimestamp();
		
		dispatch(setUserDeviceId(visitorId));

		firestore.collection('sessions').doc(hcProviderId).set({
			deviceId: visitorId,
			session: 1,
			time: timestamp
		}, {merge: true})
	};
};

export const setUserDeviceId = (userDeviceId) => {
	return {
		type: SET_USER_DEVICE_ID,
		payload: userDeviceId
	};
};


